"use strict";

var Graphics = require('pixi.js').Graphics;
var Sprite = require('pixi.js').Sprite;
const _ = require('lodash');
const Entity = require('./Entity.js').Entity;
const Throttler = require('../util/Throttler.js').Throttler;
const timestamp = require('../util/Timer.js').timestamp;
const utils = require('../util/utils.js');

export let SnakeSegment = function(options){
	options = _.defaults(options, {
		direction: undefined
	});
	Entity.call(this, options);
}

SnakeSegment.swapSegment = function(segment1, segment2) {
	utils.swapObjectKeys(segment1, segment2, [
		'x', 'y', 'direction', 'next', 'prev'
	]);

	// Make sure adjacent segments point to the swapped segments
	if (segment1.next) segment1.next.prev = segment1;
	if (segment1.prev) segment1.prev.next = segment1;
	if (segment2.next) segment2.next.prev = segment2;
	if (segment2.prev) segment2.prev.next = segment2;
}

SnakeSegment.prototype = Object.create(Entity.prototype);
SnakeSegment.prototype.constructor = SnakeSegment;

SnakeSegment.prototype.update = function(dt) {
	if (this.next) {
		this.next.update(dt);
	}
};

SnakeSegment.prototype.addTail = function(length, direction = {x:0, y:0}) {
	if (this.next) {
		return this.next.addTail(length);
	}

	this.tailSegment = length;
	if (length == 0) {
		return;
	}

	this.next = new SnakeSegment({
		stage: this.stage,
		prev: this,
		x: this.x - direction.x * this.width,
		y: this.y - direction.y * this.height,
		direction: _.clone(this.direction),
	});

	this.next.addTail(length-1, direction);
}

SnakeSegment.prototype.remove = function() {
	Entity.prototype.remove.call(this);
	if (this.next) {
		this.next.remove();
	}
}

SnakeSegment.prototype.setPosition = function(x, y) {
	const oldPosition = {
		x: this.x,
		y: this.y
	};

	Entity.prototype.setPosition.call(this, x, y);

	if (this.next !== undefined) {
		this.next.setPosition(oldPosition.x, oldPosition.y);
		this.next.direction = this.direction;
	}
}

SnakeSegment.prototype.getLastSegment = function() {
	if (this.next !== undefined) {
		return this.next.getLastSegment();
	} else {
		return this;
	}
}

SnakeSegment.prototype.visitSegments = function(fn) {
	fn(this);
	if (this.next !== undefined) {
		this.next.visitSegments(fn);
	}
}

SnakeSegment.prototype.createGraphics = function() {
	// draw a shape
	let graphics = new Graphics();
	graphics.lineStyle(1, 0xBBFF33, 0.1);
	graphics.beginFill(0xBBFF33, 0.85);

	graphics.drawRoundedRect(0, 0, this.width, this.height, this.radius);
	graphics.endFill();
	graphics.x = this.x;
	graphics.y = this.y;
	graphics = new Sprite(graphics.generateTexture(false));
	graphics.anchor.set(0.5, 0.5);
	graphics.scale.set(0, 0);
	return graphics;
};






/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/entities/SnakeSegment.js
 **/